import TagManager from 'react-gtm-module'

export function sendChangeTransportGTM(priceChange: number, priceChangePerPerson: number): void {
  TagManager.dataLayer({
    dataLayer: {
      event: 'change_transport',
      total_price_change: priceChange,
      total_price_change_per_person: priceChangePerPerson,
    },
  })
}
